var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseOne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.70264 28.5846C3.70264 14.7314 14.9328 3.50122 28.786 3.50122C42.6391 3.50122 53.8693 14.7314 53.8693 28.5846C53.8693 42.4377 42.6391 53.6679 28.786 53.6679C14.9328 53.6679 3.70264 42.4377 3.70264 28.5846ZM28.786 7.00122C16.8658 7.00122 7.20264 16.6644 7.20264 28.5846C7.20264 40.5047 16.8658 50.1679 28.786 50.1679C40.7061 50.1679 50.3693 40.5047 50.3693 28.5846C50.3693 16.6644 40.7061 7.00122 28.786 7.00122Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6232 20.7474C37.3066 21.4309 37.3066 22.5389 36.6232 23.2223L23.4239 36.4216C22.7405 37.1051 21.6324 37.1051 20.949 36.4216C20.2656 35.7382 20.2656 34.6302 20.949 33.9468L34.1483 20.7474C34.8317 20.064 35.9398 20.064 36.6232 20.7474Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.949 20.7474C21.6324 20.064 22.7405 20.064 23.4239 20.7474L36.6232 33.9468C37.3066 34.6302 37.3066 35.7382 36.6232 36.4216C35.9398 37.1051 34.8317 37.1051 34.1483 36.4216L20.949 23.2223C20.2656 22.5389 20.2656 21.4309 20.949 20.7474Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseOne);
export default __webpack_public_path__ + "static/media/close-one.d1027252.svg";
export { ForwardRef as ReactComponent };